import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { DateProvider } from '../../../providers';
import LogoImg from './logo.svg';
import {
  Container,
  CupLeft,
  CupRight,
  Logo,
  PointsContainer,
  PointsItem,
  TeamNameAway,
  TeamNameHome,
  Timer,
} from './styles';

function SoccerSupercopa2023({ data }) {
  const { awayTeam, homeTeam, status, time } = data;
  const [, refresh] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => refresh(Date.now()), 1000);
    if (status === 'paused') clearInterval(interval);
    return () => {
      clearInterval(interval);
    };
  }, [status]);

  const getTime = () => {
    if (time.length === 0) return '00:00';
    const [minutes, seconds] = DateProvider.getSoccerTime(time);
    return `${minutes}:${seconds}`;
  };

  return (
    <>
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <Container>
        <svg
          width="24"
          height="46"
          viewBox="0 0 24 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="12" width="12" height="46" fill="#232335" />
          <path
            d="M0 0H7V35.6158C10.8946 44.6621 15.1246 45.6665 17 45.659C8.52901 46.757 3.84878 45.6499 0 35.6158V0Z"
            fill={homeTeam?.colors?.[0]?.value || '#AC0D4C'}
          />
          <path
            d="M7 0H14V35.6158C17.8946 44.6621 22.1246 45.6665 24 45.659C15.529 46.757 10.8488 45.6499 7 35.6158V0Z"
            fill={homeTeam?.colors?.[1]?.value || 'black'}
          />
        </svg>
        <TeamNameHome>{homeTeam.name}</TeamNameHome>
        <CupLeft
          width="19"
          height="46"
          viewBox="0 0 19 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.27206 36.4647C7.98245 39.8926 11.4135 42.6808 15.3215 44.6312C16.328 45.1478 17.3506 45.6064 18.3692 46H10.2306C6.53204 42.6276 4.28861 38.5794 3.31725 35.749C5.02102 34.9567 6.47738 33.7145 7.53 32.1564C8.58263 30.598 9.1916 28.7822 9.29175 26.9036C9.60954 23.3494 8.60766 19.0063 6.46948 14.6691C4.65496 10.9805 2.18094 7.6587 0 5.98267L6.49384 0C8.36249 2.97435 9.94763 6.11818 11.2283 9.39006C13.7147 15.8313 14.4234 21.447 13.3421 26.0776C12.2852 30.5678 9.66435 33.9752 5.321 36.422H5.27206V36.4647Z"
            fill="#EB482B"
          />
        </CupLeft>
        <PointsContainer>
          <PointsItem>{homeTeam.points}</PointsItem>
          <Logo alt="Logo Copa del Rey" src={LogoImg} />
          <PointsItem>{awayTeam.points}</PointsItem>
        </PointsContainer>
        <CupRight
          width="19"
          height="46"
          viewBox="0 0 19 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.0971 36.4647C10.3867 39.8926 6.95568 42.6808 3.04764 44.6312C2.04111 45.1478 1.01852 45.6064 -1.14441e-05 46H8.13857C11.8371 42.6276 14.0805 38.5794 15.0519 35.749C13.3481 34.9567 11.8918 33.7145 10.8391 32.1564C9.78651 30.598 9.17754 28.7822 9.0774 26.9036C8.7596 23.3494 9.76148 19.0063 11.8997 14.6691C13.7142 10.9805 16.1882 7.6587 18.3691 5.98267L11.8753 0C10.0066 2.97435 8.42151 6.11818 7.14085 9.39006C4.65443 15.8313 3.94576 21.447 5.02703 26.0776C6.08394 30.5678 8.70479 33.9752 13.0481 36.422H13.0971V36.4647Z"
            fill="#EB482B"
          />
        </CupRight>
        <TeamNameAway>{awayTeam.name}</TeamNameAway>
        <svg
          width="24"
          height="46"
          viewBox="0 0 24 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="11"
            height="46"
            transform="matrix(-1 0 0 1 11 0)"
            fill="#232335"
          />
          <path
            d="M24 0H17V35.6158C13.1054 44.6621 8.87537 45.6665 7 45.659C15.471 46.757 20.1512 45.6499 24 35.6158V0Z"
            fill={awayTeam?.colors?.[1]?.value || '#0D539D'}
          />
          <path
            d="M17 0H10V35.6158C6.1054 44.6621 1.87537 45.6665 0 45.659C8.47099 46.757 13.1512 45.6499 17 35.6158V0Z"
            fill={awayTeam?.colors?.[0]?.value || 'white'}
          />
        </svg>

        <Timer>{getTime()}</Timer>
      </Container>
    </>
  );
}

SoccerSupercopa2023.propTypes = {
  data: PropTypes.shape({
    awayTeam: PropTypes.shape({
      colors: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.string,
        })
      ),
      image: PropTypes.string,
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    homeTeam: PropTypes.shape({
      colors: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.string,
        })
      ),
      image: PropTypes.string,
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    status: PropTypes.string,
    time: PropTypes.arrayOf(PropTypes.number),
  }),
  styles: PropTypes.shape({}),
};

SoccerSupercopa2023.defaultProps = {
  data: {
    awayTeam: {
      colors: ['#74ACDF'],
      image:
        'https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Flag_of_Argentina.svg/1200px-Flag_of_Argentina.svg.png',
      name: 'ARG',
      points: 1,
    },
    homeTeam: {
      colors: ['#E50A38'],
      image:
        'https://www.banderasphonline.com/wp-content/uploads/2021/08/comprar-bandera-espana-sin-escudo-para-exterior-interior-1200x900.png',
      name: 'ESP',
      points: 0,
    },
    status: 'paused',
    time: [],
  },
  styles: {},
};

export default SoccerSupercopa2023;
